import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_8zt5xb283v: FaireBrandEntity = {
  token: "b_8zt5xb283v",
  type: "brand",
  name: "Candlefish",
  avatarUrl:
    "https://cdn.faire.com/fastly/e4b160f355d256ffddb753d18ee39e9d69a37f65ab33ac6fd9cf50557fa0b604.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/de9bd694a06baece624336f9d36bde0dce733836e854a8fc4996f2e43b506a93.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e4b160f355d256ffddb753d18ee39e9d69a37f65ab33ac6fd9cf50557fa0b604.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/de9bd694a06baece624336f9d36bde0dce733836e854a8fc4996f2e43b506a93.jpeg",
  location: "Charleston, SC, USA",
  minimumOrderDollars: 200,
  rating: 4.9,
  reviewCount: 146,
  isInsider: true,
  description:
    "Created by the folks at Rewined candles, Candlefish is an extraordinary candle shop. \nOur Chandlers (candle makers) are experts in all things candles. It’s our goal here at Candlefish to provide a memorable, fun, and “nose-opening” experience for every single candle loving customer. Part of enjoying the experience is making you feel right at home exploring our Library of candles so you can discover your favorite scents with ease.",
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:06:22.325Z",
    importedBy: "entity-db-cli",
  },
};
